import * as React from 'react';
import workflowsPlatformIos from '../../../assets/workflows-platform-ios.svg';
import workflowsPlatformIosSDK from '../../../assets/workflows-platform-ios-sdk.svg';
import workflowsPlatformTvos from '../../../assets/workflows-platform-tvos.svg';
import workflowsPlatformVisionos from '../../../assets/workflows-platform-visionos.svg';
import workflowsPlatformWearos from '../../../assets/workflows-platform-wear-os.svg';
import workflowsPlatformAndroid from '../../../assets/workflows-platform-android.svg';
import workflowsPlatformAndroidSDK from '../../../assets/workflows-platform-android-sdk.svg';
import workflowsPlatformAndroidTV from '../../../assets/workflows-platform-android-tv.svg';
import workflowsPlatformReactNative from '../../../assets/workflows-platform-react-native.svg';
import workflowsPlatformWatchOS from '../../../assets/workflows-platform-watchos.svg';
import workflowsPlatformSamsung from '../../../assets/workflows-platform-samsung.svg';
import workflowsPlatformHuawei from '../../../assets/workflows-platform-huawei.svg';
import workflowsPlatformAmazon from '../../../assets/workflows-platform-amazon.svg';

import { AppPlatform, AppStoreType } from '@/types';
import { IconProps } from '@/typescriptHelpers';

interface WorkflowsPlatformIconProps extends IconProps {
    platform: AppPlatform;
    appStoreType?: AppStoreType;
}

const ALTERNATIVE_STORE_ICONS: Partial<Record<AppStoreType, string>> = {
    [AppStoreType.Samsung]: workflowsPlatformSamsung,
    [AppStoreType.Huawei]: workflowsPlatformHuawei,
    [AppStoreType.Amazon]: workflowsPlatformAmazon,
};

const WorkflowsPlatformIcon: React.FC<WorkflowsPlatformIconProps> = (props: WorkflowsPlatformIconProps) => {
    let iconSource: string | undefined = props.appStoreType && ALTERNATIVE_STORE_ICONS[props.appStoreType];

    if (iconSource) {
        return <img src={iconSource} width={props.width} height={props.height} />;
    }

    switch (props.platform) {
        case AppPlatform.Ios:
            iconSource = workflowsPlatformIos;
            break;
        case AppPlatform.IosSDK:
            iconSource = workflowsPlatformIosSDK;
            break;
        case AppPlatform.TvOS:
            iconSource = workflowsPlatformTvos;
            break;
        case AppPlatform.VisionOS:
            iconSource = workflowsPlatformVisionos;
            break;
        case AppPlatform.WearOS:
            iconSource = workflowsPlatformWearos;
            break;
        case AppPlatform.Android:
            iconSource = workflowsPlatformAndroid;
            break;
        case AppPlatform.AndroidSDK:
            iconSource = workflowsPlatformAndroidSDK;
            break;
        case AppPlatform.AndroidTV:
            iconSource = workflowsPlatformAndroidTV;
            break;
        case AppPlatform.ReactNativeOTA:
        case AppPlatform.ExpoEAS:
            iconSource = workflowsPlatformReactNative;
            break;
        case AppPlatform.WatchOS:
            iconSource = workflowsPlatformWatchOS;
            break;
        case AppPlatform.Samsung:
            iconSource = workflowsPlatformSamsung;
            break;
        case AppPlatform.Huawei:
            iconSource = workflowsPlatformHuawei;
            break;
        case AppPlatform.Amazon:
            iconSource = workflowsPlatformAmazon;
            break;
    }

    return <img src={iconSource} width={props.width} height={props.height} />;
};

export default WorkflowsPlatformIcon;
